import React, { Component } from 'react';
import axios from 'axios'
import { Form, Segment, Button, } from 'semantic-ui-react'
import { firebaseAuth, pythonApiIp, toCurrency, logComponentLoad, logDashboardAction } from '../../../../config/constants'
import { checkAdminEmail } from '../algoliaDashboard/AlgoliaMiscUtils';
import * as UiConsts from '../../../../config/UiConstants';
import Select from 'react-select';
import { SingleDatePicker } from 'react-dates';

import { getShirtTypesToDisplay } from './ApiUtils'

import createBrowserHistory from 'history/createBrowserHistory';
const history = createBrowserHistory({ forceRefresh: true });

class EditProjectCost extends Component {
    constructor(props) {
        super(props);
        this.state = {
            description: '',
            shirtTypeChoices: [],
            loading: true,
            qty: '',
            cost: '',
            customerId: '',
            projectId: '',
            shirtTypeId: '',
            shirtTypeChoices: '',
            shirttype: '',
            shirtTypeId: '',
            projectName: '',
            algoliaUser: ''
        }
    }

    componentDidMount() {
        console.log("addx2 ++++++++++ searchNow componentDidMount");

        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("addx24 +++++++++:firebaseAuth().onAuthStateChanged");

            if (user) {
                console.log("addx241 user is:" + user.email);
                // let isAnonymous = user.isAnonymous;
                // let uid = user.uid;

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //when viewing single project from ViewSinglelargeProject we pass the projectId
                    //this.props.match.params.artist
                    // if (this.props.match.params.costId) {

                    //     this.getProjectCost();

                    // } else {
                    //     alert("No Project Cost Id Sent")

                    // }

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)
                    // this.getApiDetails();
                    //getShirtTypes(this.loadShirtTypes);
                    getShirtTypesToDisplay(this.setShirtTypeDropDown, "large_projects");
                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })

            }
        })

    }

    setAdminResult = (returnObject) => {
        //console.log("++++++ addx294 setAdminResult");
        // console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));

        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })

        logComponentLoad(returnObject, "EditProjectCost");

        if (returnObject.algoliaUser.perms && returnObject.algoliaUser.perms.includes("editProjectCosts")) {
            if (this.props.match.params.costId) {

                this.getProjectCost();

            } else {
                alert("No Project Cost Id Sent")

            }
        }
    }

    setShirtTypeDropDown = (shirtTypes) => {
        console.log("gshtx21 +++++++:setShirtTypeDropDown");
        //console.log("gshtx22:" + JSON.stringify(shirtTypes, null, 3));
        this.setState({
            loading: false,
            shirtTypeChoices: shirtTypes
        })

    }

    // loadShirtTypes = (shirtTypes) => {
    //     console.log("gsht ++++++++:loadSalesPeopleDropdown");
    //    // console.log("gtc15:"+JSON.stringify(shirtTypes,null,3));
    //     if(shirtTypes && shirtTypes.length > 0){
    //         console.log("gtc15 customer dropdown...")
    //         this.setState({
    //             shirtTypeChoices: getShirtTypeDownDown(shirtTypes)
    //         })
    //     }else{
    //         alert("unable to load cost items")
    //     }
    // }

    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }

    getProjectCost = () => {
        console.log("++++++++:getProjectCost");

        this.setState({ loading: true })

        axios.post(pythonApiIp + 'getProjectCost', {
            apiKey: "asdfs&3asdf^",
            costId: this.props.match.params.costId,
            projectId: this.props.match.params.projectId
        })
            .then((response) => {
                this.setState({ loading: false })
                console.log("svxx:"+JSON.stringify(response.data,null,3));

                if (response.data.project) {
                    //console.log("svxx2 project exists");
                    this.setState({
                        projectName: response.data.project.name
                    })
                } else {
                    console.log("svxx2 project does not exists");
                }

                if (response.data.result) {
                    console.log("true.. adding customer");

                    // SET SALES PEOPLE DROP DOWN
                    if (response.data.projectCost) {
                        console.log("svxx1 projectCost exists");
                        this.setState({
                            qty: response.data.projectCost.qty,
                            cost: response.data.projectCost.cost,
                            shirttype: response.data.projectCost.shirttypes.shirttype,
                            shirtTypeId: response.data.projectCost.shirttypes.idshirtypes,
                            description: response.data.projectCost.description,

                        })
                         //logDashboardAction(logAction, adminEmail, order_num, componentName) {
                    logDashboardAction(this.state.user.email+" loaded cost #"+response.data.projectCost.idlargeprojectcosts+" -"+response.data.projectCost.shirttypes.shirttype+" for "+response.data.project.name,this.state.user.email,null,"EditProjectCost");
                    }


                } else {
                    console.log("FAILED");
                    alert(response.data.message);
                }
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    loading: false
                })
            });

    }

    handleDropDownChanges = (value) => {
        console.log("lst1 handleDropDownChanges");
        console.log('lst12 You\'ve sss:', value);
        console.log("lst13 category alone:" + value.category);
        console.log('lst14 You\'ve selected:', value.value + " " + value.category);
        console.log("lst15 -  this.props.itemSelected:" + this.state.itemSelected);
        console.log("lst16 - array index:" + this.props.arrayIndex);

        let newState = {};
        newState[value.category] = value.value;
        console.log("newState 1:" + JSON.stringify(newState, null, 3));

        //this.setState(newState);
        this.setState(newState);
    }

    resetFeilds = () => {
        this.setState({
            description: '',
            qty: '',
            cost: '',
            shirtTypeId: ''
        })
    }


    dateSelectOnChange = (date) => {
        console.log("++++++++:dateSelectOnChange");
        console.log("date:" + date);
        console.log("date.getValue():" + date.valueOf());
        this.setState({
            date: date,
            dateNum: date.valueOf(),
            dateString: date.format('dddd MMMM Do')

        })
    }

    sendProjectCosts = () => {
        console.log("++++++++:sendCustomer");
        console.log("description:" + this.state.description)
        console.log("costId:" + this.state.costId)
        console.log("qty:" + this.state.qty)
        console.log("shirtTypeId:" + this.state.shirtTypeId)
        console.log("cost:" + this.state.cost)
        console.log("enteredBy:" + this.state.user.email)
        console.log("projectName:" + this.state.projectName)
        console.log("projectId:" + this.state.projectId)



        if (this.state.description == '') {
            alert("No description Name")
        } else if (this.state.costId == '') {
            alert("No costId Selected")
        } else if (this.state.qty == '') {
            alert("No qty Entered")
        } else if (this.state.cost == '') {
            alert("No cost Entered")
        } else if (this.state.shirtTypeId == '') {
            alert("No Shirt Type Selected")
        } else if (this.state.user.email == '') {
            alert("No Entered By Provided")
        } else if (this.state.projectName == '') {
            alert("No projectName Entered")
        }
        else {
            console.log("sending data..");

            this.setState({ loading: true });

            // let temp = {
            //     apiKey: "PrintB@da7",
            //     description: this.state.description,
            //     projectId: this.state.projectId,
            //     qty: this.state.qty,
            //     cost: this.state.cost,
            //     enteredBy: this.state.user.email,
            //     shirtTypeId: this.state.shirtTypeId,
            //     dateSpent: this.state.dateNum
            // }


            //this.props.match.params.costId
            axios.post(pythonApiIp + 'editProjectCost', {
                apiKey: "asdf^43",
                description: this.state.description,
                costId: this.props.match.params.costId,
                qty: this.state.qty,
                cost: this.state.cost,
                enteredBy: this.state.user.email,
                shirtTypeId: this.state.shirtTypeId,
                projectName: this.state.projectName,
                projectId: this.props.match.params.projectId,
                //dateSpent: this.state.dateNum

            })
                .then((response) => {

                    console.log(response.data);

                    if (response.data.result) {
                        console.log("true.. cost modified");

                        this.resetFeilds();
                        this.setState({
                            loading: false,
                            // showProjectCosts: true,
                            // projectCosts: response.data.projectCosts
                        })


                        alert(response.data.message);

                        if(this.props.match.params.platform && this.props.match.params.platform == 'mobile'){

                            console.log("platform is: "+this.props.match.params.platform);
                            history.push("/dashboard/mobileEnterProjectCosts/" + this.props.match.params.projectId);
                        }else{

                            console.log("platform is mobile"+this.props.match.params.platform);
                            history.push("/dashboard/viewLargeProject/" + this.props.match.params.projectId);
                        }
                       
                    } else {
                        console.log("FAILED");
                        this.setState({
                            loading: false,

                        })
                        alert(response.data.message);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.setState({
                        loading: false
                    })
                });
        }
    }

    deleteCost = () => {
        console.log("++++++++:sendCustomer");
        console.log("description:" + this.state.description)
        console.log("costId:" + this.state.costId)

        if (this.state.description == '') {
            alert("No description Name")
        } else if (this.state.costId == '') {
            alert("No costId Selected")
        } else if (this.state.user.email == '') {
            alert("No Entered By Provided")
        }
        else {
            console.log("sending data..");

            this.setState({ loading: true });

            //this.props.match.params.costId
            axios.post(pythonApiIp + 'deleteProjectCost', {
                apiKey: "PrintB@da7",
                costId: this.props.match.params.costId,
                enteredBy: this.state.user.email,
            })
                .then((response) => {

                    console.log(response.data);

                    if (response.data.result) {
                        console.log("true.. cost modified");

                        this.resetFeilds();
                        this.setState({
                            loading: false,
                        })


                        alert(response.data.message);
                        history.push("/dashboard/viewLargeProject/" + this.props.match.params.projectId);
                    } else {
                        console.log("FAILED");
                        this.setState({
                            loading: false,

                        })
                        alert(response.data.message);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.setState({
                        loading: false
                    })
                });
        }
    }

    render() {

        // const projectsDropdown = this.state.projectChoices.length > 0 && !this.props.projectId
        //     ? <Select
        //         name="form-field-name"
        //         value={this.state.projectId}
        //         options={this.state.projectChoices}
        //         onChange={this.handleDropDownChanges}
        //         searchable={false}
        //         clearable={false}
        //     />
        //     : ''

        const shirtTypeDropdown = this.state.shirtTypeChoices.length > 0
            ? <Select
                name="form-field-name"
                value={this.state.shirtTypeId}
                options={this.state.shirtTypeChoices}
                onChange={this.handleDropDownChanges}
                searchable={false}
                clearable={false}
            />
            : ''

        const wholeUI = this.state.algoliaUser && this.state.algoliaUser != '' && this.state.algoliaUser.perms && this.state.algoliaUser.perms.includes("editProjectCosts")
            ? <div>
                <h1>EDIT {this.state.projectName} </h1>

                <h1>{this.props.match.params.costId}</h1>


                <Form size='large' onSubmit={this.sendProjectCosts}>
                    <Segment stacked>

                        {/* <label>Select Project</label>
        {projectsDropdown} */}

                        <label>Enter ProjectName</label>
                        <Form.Input
                            fluid
                            icon='blind'
                            iconPosition='left'
                            placeholder='Description'
                            type='text'
                            name="projectName"
                            value={this.state.projectName}
                            onChange={this.handleTextInputChange}
                        />


                        <label>Enter Description</label>
                        <Form.Input
                            fluid
                            icon='blind'
                            iconPosition='left'
                            placeholder='Description'
                            type='text'
                            name="description"
                            value={this.state.description}
                            onChange={this.handleTextInputChange}
                        />

                        <label>Enter Qty</label>
                        <Form.Input
                            fluid
                            icon='money'
                            iconPosition='left'
                            placeholder='Qty'
                            type='number'
                            name="qty"
                            value={this.state.qty}
                            onChange={this.handleTextInputChange}
                        />

                        <label>Enter Cost</label><br />
                        <label>{toCurrency(this.state.cost)}</label>
                        <Form.Input
                            fluid
                            icon='money'
                            iconPosition='left'
                            placeholder='Cost'
                            type='number'
                            name="cost"
                            value={this.state.cost}
                            onChange={this.handleTextInputChange}
                        />

                        <br />
                        <label>Select Items</label>
                        {shirtTypeDropdown}

                        <SingleDatePicker
                            date={this.state.date} // momentPropTypes.momentObj or null
                            //onDateChange={date => this.setState({ date })} // PropTypes.func.isRequired
                            onDateChange={date => this.dateSelectOnChange(date)} // PropTypes.func.isRequired
                            focused={this.state.focused} // PropTypes.bool
                            isOutsideRange={() => false}
                            onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
                        />
                        <h2>{this.state.dateString}</h2>

                        <Button>SEND</Button>
                    </Segment>

                    <Button color='red' onClick={this.deleteCost}> DELETE COST</Button>

                </Form>

            </div>
            : <h4>loading error a75</h4>

        //const projectCosts = this.state.showProjectCosts && this.state.projectId && !this.props.projectId
        // const projectCosts = this.props.projectId
        //     ? <ViewLargeProjectCosts projectId={this.props.projectId} projectCosts={this.state.projectCosts} />
        //     : ''

        return (
            this.state.loading ? <UiConsts.LoadingComponent /> : <div>

                {wholeUI}


            </div>
        );
    }
}

export default EditProjectCost;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjects/EditProjectCost.js